import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { KLogo } from "@/components/KLogo";

const NAV = [
  { key: "home", href: "#accueil" },
  { key: "about", href: "#a-propos" },
  { key: "services", href: "#services" },
  { key: "contact", href: "#contact" },
];

export const Header = () => {
  const { t, lang, toggleLang } = useLang();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!t) return null;
  const nav = t.nav;

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-creme/80 backdrop-blur-md border-b transition-colors ${
        scrolled ? "border-ligne shadow-[0_1px_0_rgba(25,22,19,0.04)]" : "border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-[68px] flex items-center justify-between gap-4">
        <a href="#accueil" className="flex items-center" data-testid="header-logo" aria-label="KHuma">
          <KLogo className="h-9 w-auto" />
        </a>

        <nav data-testid="header-nav" className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.key}
              href={item.href}
              data-testid={`nav-${item.key}`}
              className="text-sm text-noir/80 hover:text-rouge transition-colors duration-200 tracking-wide"
            >
              {nav[item.key]}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-lang-toggle"
            onClick={toggleLang}
            className="text-xs font-medium tracking-widest text-noir/70 hover:text-noir transition-colors"
            aria-label="Switch language"
          >
            <span className={lang === "fr" ? "text-rouge" : ""}>FR</span>
            <span className="mx-1 text-ligne">|</span>
            <span className={lang === "en" ? "text-rouge" : ""}>EN</span>
          </button>

          <button
            data-testid="mobile-menu-button"
            className="md:hidden p-2 text-noir"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
            aria-expanded={open}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-ligne bg-creme" data-testid="mobile-menu">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.key}
                href={item.href}
                data-testid={`mobile-nav-${item.key}`}
                onClick={() => setOpen(false)}
                className="py-3 text-base text-noir/85 border-b border-ligne/60 last:border-0"
              >
                {nav[item.key]}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
